
import { useEffect } from "react";
import { useBlogs } from "../../loadBlogs";
import BlogItem from "../Blog/Blog";
export default function BlogContainer() {
    const [blogs, loading] = useBlogs()
    return (
        <div className="blog-continer w-fit mx-auto">
            {
                loading ? "Loading..." : <div className="blogs flex flex-col space-y-10">
                    {
                        blogs?.map(e => {
                            return (
                                <BlogItem content={e.content} id={e.id} date={e.date} title={e.title} key={e.id}/>
                            )
                        })
                    }
                </div>
            }
        </div>
    );
}